import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom"

import GlobalState from './GlobalState';
import { Provider } from "react-redux"

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <Provider store={GlobalState}>
      <App />
    </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
